import React from 'react';
import './Header.css'; // Create a CSS file for footer styles

const Footer = () => {
  return (
    <header className="properties-header">
        <a href='./' style={{height:'20px',}}><img src='/imgs/domorango.png'  alt="My" className="header-logo" /></a>
    </header>
  );
};

export default Footer;
